import instance, { formDataInstance } from "./baseRequest";

export const aboutApi = {
  getAbout: async () => await instance.get("/about"),
  updateAbout: async (data, media1File, media2File) => {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("description", data.description);

    if (media1File) formData.append("media1", media1File);
    if (media2File) formData.append("media2", media2File);

    return await formDataInstance.put("/about", formData);
  },
};
